import style from './index.scss'
import { Link } from 'preact-router/match';
import { Component } from 'preact';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-121213692-1');


class Layout extends Component {

    render(props,state){
        let isHome = (props.isHome);
        if (typeof window !== "undefined") {
            ReactGA.pageview(window.location.pathname + window.location.search);
        }
      return (
          <div className="wrapper">
            
              {!isHome && (<ul className="layout__nav">
                  <li><Link href="/">&lt; Back to games</Link></li>
              </ul>)}
            <div className="layout__content">
              {props.children}
            </div>

            <div className="footer">
                <small>All Images &copy; Dinosaurs Doing Stuff 2022<br/>No reproduction without express permission</small>
            </div>
          </div>
      )
    }
}

export default Layout;



// WEBPACK FOOTER //
// ./components/layout/index.js